// Phase 14 — SE Home widget: Targets snapshot
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Target as TargetIcon, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

function Bar({ pct, onTrack }) {
  return (
    <div className="w-full h-1.5 bg-neutral-100 rounded-full overflow-hidden">
      <div className={`h-full ${onTrack ? "bg-emerald-500" : "bg-rose-500"}`} style={{ width: `${Math.min(100, pct || 0)}%` }} />
    </div>
  );
}

export default function MyTargetsCard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/targets/mine").then(r => setItems((r.data.items || []).slice(0, 3))).finally(() => setLoading(false));
  }, []);
  if (loading || items.length === 0) return null;
  return (
    <Link to="/targets/mine" data-testid="targets-home-card" className="block bg-white rounded-xl border p-3 shadow-sm hover:shadow-md transition">
      <div className="flex items-center gap-2 mb-2">
        <TargetIcon className="w-4 h-4 text-[#E5197F]" />
        <div className="font-medium text-sm flex-1">My targets</div>
        <ChevronRight className="w-4 h-4 text-neutral-400" />
      </div>
      <div className="space-y-2">
        {items.map(t => (
          <div key={t.id}>
            <div className="flex justify-between text-xs mb-1">
              <span className="truncate max-w-[70%]">{t.dimension.replace(/_/g, " ")} · {t.period_key}</span>
              <span className="font-semibold">{(t.achievement_pct ?? 0).toFixed(0)}%</span>
            </div>
            <Bar pct={t.achievement_pct} onTrack={t.on_track} />
          </div>
        ))}
      </div>
    </Link>
  );
}
